"use client"

import { useEffect, useState } from "react"
import Script from "next/script"
import { aceptoAnalitica, CONSENTIMIENTO_CAMBIADO, estoyEnLaApp } from "@/lib/comun/en-la-app"

const GA_MEASUREMENT_ID = "G-NG81Y1T92X"

/**
 * Google Analytics: solo en la web, y solo si se aceptó la analítica.
 *
 * **Antes se cargaba siempre**, también a quien rechazaba las cookies y también
 * dentro de las apps. Lo primero no cumple el RGPD; lo segundo hizo que App
 * Store rechazara la app de iOS por rastrear sin App Tracking Transparency.
 * Ahora:
 *
 * - Dentro de las apps (escritorio, iOS, Android) no se carga nunca
 *   (`estoyEnLaApp`).
 * - En la web, cuando la persona acepta la analítica en el aviso de cookies; si
 *   la acepta después, se carga en ese momento (`CONSENTIMIENTO_CAMBIADO`).
 *
 * Con `afterInteractive`: no va por delante del contenido propio.
 */
export default function GoogleAnalytics() {
  const [cargar, setCargar] = useState(false)

  useEffect(() => {
    const mirar = () => setCargar(!estoyEnLaApp() && aceptoAnalitica())
    mirar()
    window.addEventListener(CONSENTIMIENTO_CAMBIADO, mirar)
    return () => window.removeEventListener(CONSENTIMIENTO_CAMBIADO, mirar)
  }, [])

  if (!cargar) return null

  return (
    <>
      <Script src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`} strategy="afterInteractive" />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${GA_MEASUREMENT_ID}');
        `}
      </Script>
    </>
  )
}
